import { render, staticRenderFns } from "./ImportExcelRewardAffiliate.vue?vue&type=template&id=1ca18231"
import script from "./ImportExcelRewardAffiliate.vue?vue&type=script&lang=js"
export * from "./ImportExcelRewardAffiliate.vue?vue&type=script&lang=js"
import style0 from "./ImportExcelRewardAffiliate.vue?vue&type=style&index=0&id=1ca18231&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports